
export default {
    getPoint(point) {
        /** 先求4个坐标点，把旋转前和旋转后的点加上中心点看成一个等腰三角形就好解决了,不用扇形公式,而是用三角形公式.
            假设矩形的左上角为（left, top),右下角为（right, bottom),则矩形上任意点（x0, y0）绕其中心（xcenter,ycenter)逆时针旋转angle角度后,新的坐标位置（x′, y′）的计算公式为：

            假设对图片上任意点(x,y)，绕一个坐标点(rx0,ry0)逆时针旋转a角度后的新的坐标设为(x0, y0)，
             x0= (x - rx0)*cos(a) - (y - ry0)*sin(a) + rx0 ;
             y0= (x - rx0)*sin(a) + (y - ry0)*cos(a) + ry0 ;
        */
        const angle = - point.rotate / 180 * Math.PI //角度

        const w = point.width / 2;
        const h = point.height / 2;

        // 坐标轴是从头右下角
        // point.y = point.y;

        let topRight = {}
        let topLeft = {}
        let bottomRight = {}
        let bottomLeft = {}

        topRight.x = bottomRight.x = point.x + w

        bottomRight.y = bottomLeft.y = point.y - h
        topLeft.y = topRight.y = point.y + h
        bottomLeft.x = topLeft.x = point.x - w

        // console.log('====>', topRight, bottomRight, bottomLeft, topLeft)

        const getX0Y0 = (x, y) => {
            return [
                Math.round((x) * Math.cos(angle) - (y) * Math.sin(angle) + point.x),
                Math.round((x) * Math.sin(angle) + (y) * Math.cos(angle) + point.y)
            ]
        }

        if (point.rotate === 0 || point.rotate === 180 || point.rotate === 360) {
            return [
                [Math.round(topRight.x), Math.round(topRight.y)],
                [Math.round(bottomRight.x), Math.round(bottomRight.y)],
                [Math.round(bottomLeft.x), Math.round(bottomLeft.y)],
                [Math.round(topLeft.x), Math.round(topLeft.y)]
            ]
        }

        let res = [
            getX0Y0(topRight.x - point.x, topLeft.y - point.y),
            getX0Y0(bottomRight.x - point.x, bottomRight.y - point.y),
            getX0Y0(bottomLeft.x - point.x, bottomLeft.y - point.y),
            getX0Y0(topLeft.x - point.x, topLeft.y - point.y),
        ]

        if (point.rotate !== 90 && point.rotate !== 270) {
            // console.log(res)
            return [
                // 延长线，交点组成的矩形， 旋转矩形变换，取值线不会是斜的
                [res[1][0], res[0][1]],
                [res[1][0], res[2][1]],
                [res[3][0], res[2][1]],
                [res[3][0], res[0][1]],
            ]
        }
        
        return res
    },
    /**
     * 
     * @param {[array]} source  [[topRight],[bottomRight],[bottomLeft],[topLeft]]
     * @param {[array]} targets 比较对象 
     * @returns  [
  [ [ 10, -10 ], [ 10, 0 ] ],
  [ [ 0, -10 ], [ 10, -10 ] ],
  [ [ 0, 0 ], [ 0, 10 ] ]
]
     */
    intersectLine(source, targets) {

        const MAX = 1;

        let results = []

        const getMaxPoint = (a, b, c, d) => {
            let array = [a, b, c, d]
            array.sort(function (a, b) {
                return a - b
            })
            return [array[0], array[3]]
        }

        /**
         * 
         * 方向
         -------4-------
         |             |
         |             |
         3             1
         |             |
         |             |
         -------2-------
         */

        // 寻找最大延长线
        /*
            x(0,5)
            y(0,-5)
            x轴相交 找出最大的Y值

            目标拆成2个部分，整体和 一个小的延中线切割的左上部，画布拆成2个部分 水平中线以下和垂直中线右边，放入targets，小目标与之比较，不与其他组件比较
        
        */
       let r = []
        targets.forEach(target => {
            if ((source[0][0] >= target[0][0] - MAX && source[0][0] <= target[0][0] + MAX)) {
                r = getMaxPoint(source[0][1], source[1][1], target[0][1], target[1][1]).map(function (item) {
                    return [target[0][0], item]
                })
                results.push(r)
            } else  if ((source[0][0] >= target[2][0] - MAX && source[0][0] <= target[2][0] + MAX)) {
                // console.log(source,target[2][1], target[3][1])
                r = getMaxPoint(source[0][1], source[1][1], target[2][1], target[3][1]).map(function (item) {
                    return [target[3][0], item]
                })
                results.push(r)
            } 

            if (source[1][1] >= target[1][1] - MAX && source[1][1] <= target[1][1] + MAX) {
                r = getMaxPoint(source[1][0], source[2][0], target[1][0], target[2][0]).map(function (item) {
                    return [item, target[1][1]]
                })
                results.push(r)
            }else if (source[1][1] >= target[3][1] - MAX && source[1][1] <= target[3][1] + MAX) {
                r = getMaxPoint(source[1][0], source[2][0], target[3][0], target[0][0]).map(function (item) {
                    return [item, target[3][1]]
                })
                results.push(r)
            }

            if (source[3][0] >= target[3][0] - MAX && source[3][0] <= target[3][0] + MAX) {
                r = getMaxPoint(source[3][1], source[2][1], target[0][1], target[1][1]).map(function (item) {
                    return [target[3][0], item]
                })
                results.push(r)
            } 
            if (source[3][1] >= target[3][1] - MAX && source[3][1] <= target[3][1] + MAX) {
                r = getMaxPoint(source[3][0], source[0][0], target[0][0], target[1][0]).map(function (item) {
                    return [item, target[3][1]]
                })
                results.push(r)
            } else if (source[3][1] >= target[1][1] - MAX && source[3][1] <= target[1][1] + MAX) {
                r = getMaxPoint(source[3][0], source[0][0], target[2][0], target[1][0]).map(function (item) {
                    return [item, target[1][1]]
                })
                results.push(r)
            }
            


        })

        return results

    }

}
